import { cn } from "@/lib/utils";
import { usePageHeader } from "@/hooks/usePageHeader";

interface PageHeaderProps {
  title?: string;
  children?: React.ReactNode;
  className?: string;
}

export function PageHeader({ title, children, className }: PageHeaderProps) {
  usePageHeader({ title });

  if (!children) return null;

  return (
    <div className={cn("flex items-center gap-2", className)}>{children}</div>
  );
}
